import { RocketOutlined } from '@ant-design/icons';

const roadmap = {
  id: 'group-roadmap',
  title: 'Plataforma',
  type: 'group',
  children: [
    {
      id: 'roadmap',
      title: 'Roadmap',
      type: 'item',
      url: '/roadmap',
      icon: RocketOutlined,
      breadcrumbs: false
    }
  ]
};

export default roadmap;
